
import { Component, Mixins } from "vue-property-decorator";
import { default as ForegroundDrawableObjectMixin } from "./ForegroundDrawableObjectMixin.vue";
import { default as ImageDrawableMixin } from "./ImageDrawableMixin.vue";

@Component
export default class ImageDrawableObjectMixin extends Mixins(
  ForegroundDrawableObjectMixin,
  ImageDrawableMixin,
) {
}
